<template>
  <div class="achievement">
    <div class="achievement-nav">
      <div class="achievement-title">
        <van-cell-group>
          <van-cell :title="`订单数:${page.totalCount}`" :value="currentDate" is-link>
            <template #right-icon>
              <van-icon name="arrow-down" @click="showDatePicker = true" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <van-row class="achievement-list" :gutter="20">
        <van-col v-for="item in orderCount" :key="item.title" :span="8">
          <template v-if="item.filter && typeof item.filter === 'function'">
            <p>{{ item.filter(achievementCount[item.valueKey]) || 0 }}</p>
          </template>
          <p v-else>{{ achievementCount[item.valueKey] || 0 }}</p>
          <span>{{ item.title }}</span>
        </van-col>
      </van-row>
    </div>
    <List :page="page" @requestList="handleLoad">
      <OrderCell  :orderList="orderList" :cellList="cellList">
        <template v-slot:order-footer="scoped">
          <van-row class="order-footer">
            <van-col :span="12">
              <van-button size="small" @click="teamPerformance(scoped.item.id)">管理提成</van-button>
            </van-col>
            <van-col :span="12">
              <van-button
                size="small"
                @click="$router.push({ name: 'OrderDetails', query: { id: scoped.item.id, orderNo: scoped.item.orderNo } })"
              >
                查看订单
              </van-button>
            </van-col>
          </van-row>
        </template>
      </OrderCell>
    </List>
    <van-popup v-model="showTeamPerformance" round position="bottom">
      <div class="team-performance">
        <div class="team-performance-title">管理提成</div>
        <div class="team-performance-content">
          <ul>
            <template v-if="teamList.length">
              <li v-for="item in teamList" :key="item.staffName">
                {{ `${item.staffName}(${item.staffRulName})` }}
                {{ item.money | money }}
              </li>
            </template>
            <li v-else>暂无数据</li>
          </ul>
        </div>
        <div class="team-performance-footer">
          <van-button size="small" @click="showTeamPerformance = false">取消</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 日期选择器 -->
    <MonthPicker
      :currentDate.sync="currentDate"
      :showDatePicker.sync="showDatePicker"
      @changeDate="params = { ...params, ...$event }"
    />
  </div>
</template>

<script>
import { achievementList as getAchievementList, teamAchievement, countAchievement } from '@/api/achievement';
import MonthPicker from '@/components/date/monthPicker';
import List from '@/components/list';
import OrderCell from '@/components/order/cell';
import { getMonthStartTime, getMonthEndTime, currentMonth } from '@/utils';
import { orderContent, money } from '@/filters';
export default {
  components: { MonthPicker, List, OrderCell },
  data() {
    return {
      currentDate: currentMonth,
      params: { // 查询列表所需参数
        startTime: getMonthStartTime(currentMonth),
        endTime: getMonthEndTime(currentMonth)
      },
      cellList: [
        { title: '订单金额', value: 'payed', border: true, filter: money },
        { title: '订单编号', value: 'orderNo' },
        { title: '订单内容', value: 'orderType', filter: orderContent },
        { title: '成交人提成', value: 'orderSubmitOwnerRemind', filter: money },
        { title: '归属人提成', value: 'orderOwnerRemind', filter: money }
      ],
      page: {
        currentPage: 1,
        currentCount: 10,
        totalCount: 0,
        totalPage: 0
      },
      showTeamPerformance: false,
      showDatePicker: false,
      orderCount: [
        { title: '团队业绩', valueKey: 'teamPerformance', filter: money },
        { title: '个人业绩', valueKey: 'personalPerformance', filter: money },
        { title: '峰会订单数', valueKey: 'summitNum' }
      ],
      achievementCount: {}, // 业绩汇总
      orderList: [],
      teamList: []
    }
  },
  watch: {
    params: {
      handler(newVal) {
        const params = {
          ...newVal,
          page: 1,
          count: this.page.currentCount
        };
        this.getAchievementList(params, true);
        this.getCountAchievement(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /**
     * 滚动加载数据
     */
    handleLoad() {
      const { currentPage: page, currentCount: count } = this.page;
      this.getAchievementList({ page: page + 1, count, ...this.params });
    },
    /**
     * 获取业绩列表
     */
    getAchievementList(params, isClean) {
      getAchievementList(params).then((res) => {
        if (res.errcode === 0) {
          if (isClean) {
            this.orderList = res.data;
          } else {
            this.orderList = this.orderList.concat(res.data);
          }
          this.page = res.page;
        }
      })
    },
    /**
     * 获取业绩汇总
     */
    getCountAchievement(params) {
      countAchievement(params).then((res) => {
        if (res.errcode === 0) {
          this.achievementCount = res.data;
        }
      });
    },
    /**
     * 查看团队业绩
     */
    teamPerformance(orderId) {
      teamAchievement({ orderId }).then((res) => {
        if (res.errcode === 0) {
          this.showTeamPerformance = true;
          this.teamList = res.data;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.achievement {
  &-nav { background-color: #fff;  margin-bottom: 15px;
    .van-cell__value { color: #333; }
    .van-icon-arrow-down { line-height: 24px; margin-left: 10px; color: #969799; font-size: 20px; font-weight: bold; }
  }
  &-list { color: #333;
    .van-col { text-align: center; overflow: hidden; word-wrap:break-word; word-break:break-all;
     p { font-size: 18px; margin: 10px 0 !important; }
      span { font-size: 12px; display: block; margin-bottom: 10px; }
    }
  }
  .team-performance { color: #333;
    &-title { text-align: center; padding: 10px 0; font-size: 14px; }
    &-content {
      text-align: center; max-height: calc(~'40vh - 80px'); overflow-y: auto;
      ul { position: relative; height: 100%; overflow-y: auto;
        &::before {
          content: '';
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          border-top: 1px solid #ebedf0;
          transform: scaleY(.5);
        }
        li { padding: 15px 0; font-size: 12px; position: relative;
          &::after {
            content: '';
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            border-top: 1px solid #ebedf0;
            transform: scaleY(.5);
          }
        }
      }
    }
    &-footer { padding-bottom: 10px;
      .van-button { width: 100%; border: none; padding-top: 10px; }
    }
  }
}
</style>